import React, { useState, useEffect, useContext } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
// Shared "design-system" styles (.background-blue / .bg-yellow / .table-container /
// .upcoming-booking-container / .clear-margin) live in UpcomingBooking.css and are
// used by many screens (Select your Departure/Return, BookingDetails, SelectSeat, …).
// They used to reach the bundle only transitively via ManageBooking -> UpcomingBooking;
// once ManageBooking stopped importing those components the file fell out of the build
// and those bars/cards lost their styling. Import it here so it is always bundled,
// independent of which components happen to be mounted.
import './components/UpcomingBooking.css';
import {
	VoucherCodeContext,
	VoucherDiscountContext,
	OriginContext,
	LoyaltyIDContext,
	ChildAmountContext,
	ReturnDataContext,
	DepartDataContext,
	UserContext,
	SelectSeatDepartContext,
	SelectSeatReturnContext,
	TotalBusFareContext,
	BusFareDepartContext,
	BusFareReturnContext,
	BusFareAddOnContext,
	LoyaltyDiscountContext,
	VoucherCodeAirlineContext,
	InsuranceAddonContext,
	ValueMealAddonContext,
	HealthCareAddOnContext,
	CurrencyContext,
	CurrentCurrencyContext,
} from './UserContext';
// import 'bootstrap/dist/css/bootstrap.min.css';

import MainLayout from './components/MainLayout'; // Import the layout component
import Home from './components/pages/Home';
import BusSchedule from './components/pages/BusSchedule';
import ManageBooking from './components/pages/ManageBooking';
import Loyalty from './components/pages/loyalty';
import About from './components/pages/About';
import PaymentAck from './components/pages/PaymentAck';
// import BookingEdit from './components/pages/BookingEdit.js_removed';
import PickDepart from './components/pages/PickDepart';
import ProceedComponent from './components/pages/SelectSeat';
import Checkout from './components/pages/Checkout';
import PickReturn from './components/pages/PickReturn';
import { BookingStatus } from './components/pages/BookingStatus';
import MyAccount from './components/pages/MyAccount';
import ScrollToTop from './components/ScrollToTop';
import BookingHistory from './components/pages/BookingHistory';
import ResetPassword from './components/pages/ResetPassword';
import OrderSummary from './components/pages/OrderSummary';
import BookingSummary from './components/pages/BookingSummary';
import './fonts/gotham-rounded-medium.otf';
import './fonts/gotham-rounded-bold.otf';

import {
	tokenIsValid,
	getToken,
	getUserTokenExpiry,
	checkWindowLocation,
	getLoginStatus,
	clearUserToken,
	clearUserTokenExpiry,
	sessionStorageGetItem,
	sessionStorageSetItem,
} from './components/Function';
import axios from 'axios';

function App() {
	const SERVER_URL = process.env.REACT_APP_SERVER_URL;
	let [selectedDepartSeat, setDepartSeat] = useState([]);
	let [selectedReturnSeat, setReturnSeat] = useState([]);
	let [BusFareDepart, setBusFareDepart] = useState(0);
	let [BusFareReturn, setBusFareReturn] = useState(0);
	let [BusFareAddOn, setBusFareAddOn] = useState([]);
	let [TotalBusFare, setTotalBusFare] = useState(0);
	let [TotalLoyalty, setLoyalty] = useState(0);
	let [LoyaltyID, setLoyaltyID] = useState(null);
	let [VoucherDiscount, setVoucherDiscount] = useState(0);
	let [VoucherCode, setVoucherCode] = useState(null);
	let [VoucherCodeAirlineNo, setVoucherCodeAirlineNo] = useState(null);
	let [departData, setDepartData] = useState({});
	let [returnData, setReturnData] = useState({});
	let [childAmount, setChildAmount] = useState(0);

	let [origin, setOrigin] = useState('Johor Bahru');

	const [subplace_data, setSubPlaceData] = useState(null);
	let [insuranceAddOn, setInsuranceAddOn] = useState({});
	let [valueMealAddOn, setValueMealAddOn] = useState({ meal: '', fee: 0 });
	let [healthCareAddOn, setHealthCareAddOn] = useState({});
	const [exchangeCurrency, setExchangeCurrency] = useState({
		addOnCurrency: 3.5,
		busFareCurrency: 3.5,
		shuttleBusCurrency: 3.5,
	});
	const [currentCurrency, setCurrentCurrency] = useState('MYR');

	useEffect(() => {
		if (sessionStorageGetItem('currency') === null) {
			// sessionStorageSetItem('currency', JSON.stringify('MYR'));
			sessionStorageSetItem('currency', 'MYR');
			setCurrentCurrency('MYR');
		} else {
			// setCurrentCurrency(JSON.parse(sessionStorageGetItem('currency')));
			setCurrentCurrency(sessionStorageGetItem('currency'));
		}

		if (
			(getLoginStatus() == true && getUserTokenExpiry() == null) ||
			(getLoginStatus() == true && Date.now() > getUserTokenExpiry())
		) {
			sessionStorage.removeItem('login');
			sessionStorage.removeItem('loginStatus');
			sessionStorage.removeItem('userData');
			sessionStorage.removeItem('primaryEmail');
			// sessionStorage.removeItem("primaryPassword");
			sessionStorage.removeItem('userLoyaltyData');
			sessionStorage.removeItem('friendsAndFamilyData');

			//remove checkout expiry timestamp
			sessionStorage.removeItem('checkout_expiry_ts');

			clearUserToken();
			clearUserTokenExpiry();

			alert('Your session has expired, please Login again');
			sessionStorage.removeItem('rescheduleAmount');
			sessionStorage.removeItem('history_guid');
			sessionStorage.removeItem('addOn');
			sessionStorage.removeItem('oldcartguid');
			sessionStorage.removeItem('Origin_data');
			sessionStorage.removeItem('Destination_data');

			window.location.href = '/';
		}
	}, []);

	useEffect(() => {
		if (sessionStorageGetItem('Origin_data') != null) {
			const origin_data = JSON.parse(sessionStorageGetItem('Origin_data'));
			// sessionStorageSetItem('currency', JSON.stringify('MYR'));
		}
	}, [sessionStorageGetItem('Origin_data')]);

	useEffect(() => {
		const getSubPlaceData = async () => {
			try {
				const response = await fetch(`${SERVER_URL}/me/get/subplaces`, {
					headers: {
						Authorization: getToken(),
					},
				});
				if (!response.ok) {
					throw new Error(
						`This is an HTTP error: The status is ${response.status}`
					);
				}
				let actualData = await response.json();
				setSubPlaceData(actualData);
				sessionStorageSetItem('subplace_data', JSON.stringify(actualData));
			} catch (err) {
				setSubPlaceData(null);
			}
		};
		tokenIsValid();
		if (getToken() != null) {
			getSubPlaceData();
		}
	}, [getToken()]);

	useEffect(() => {
		const getCurrencyRate = async () => {
			try {
				const response = await axios.get(
					`${process.env.REACT_APP_SERVER_URL}/order/currency/exchange/SGD`,
					{
						headers: {
							'Content-Type': 'application/json',
							Authorization: getToken(),
						},
					}
				);

				if (response.data) {
					setExchangeCurrency({
						addOnCurrency: Number(
							response.data.find((d) => d.category_name === 'add-on')
								?.exchange_rate || 3.5
						),
						busFareCurrency: Number(
							response.data.find((d) => d.category_name === 'express-bus')
								?.exchange_rate || 3.5
						),
						shuttleBusCurrency: 3.5,
					});
				}
			} catch (error) {
				setExchangeCurrency({
					addOnCurrency: 3.5,
					busFareCurrency: 3.5,
					shuttleBusCurrency: 3.5,
				});
			}
		};

		const getIp = async () => {
			try {
				const ipResponse = await axios.get(
					`https://myip-api.causewaylink.com.my/api/my-ip`
				);

				if (ipResponse.data.countryCode === 'SG') {
					setCurrentCurrency('SGD');
				}
			} catch (error) {
				console.log(error);
			}
		};

		getCurrencyRate();
		getIp();
	}, []);

	useEffect(() => {
		const departBusFare = sessionStorageGetItem('departBusFare');
		const returnBusFare = sessionStorageGetItem('returnBusFare');

		if (!departBusFare) {
			sessionStorageSetItem(
				'departBusFare',
				JSON.stringify({ fare: 0, sgdFare: 0 })
			);
		}

		if (!returnBusFare) {
			sessionStorageSetItem(
				'returnBusFare',
				JSON.stringify({ fare: 0, sgdFare: 0 })
			);
		}
	}, []);

	return (
		<>
			<Router>
				<ScrollToTop />
				<CurrentCurrencyContext.Provider
					value={{ currentCurrency, setCurrentCurrency }}
				>
					<CurrencyContext.Provider
						value={{ exchangeCurrency, setExchangeCurrency }}
					>
						<DepartDataContext.Provider value={{ departData, setDepartData }}>
							<ReturnDataContext.Provider value={{ returnData, setReturnData }}>
								<SelectSeatDepartContext.Provider
									value={{ selectedDepartSeat, setDepartSeat }}
								>
									<SelectSeatReturnContext.Provider
										value={{ selectedReturnSeat, setReturnSeat }}
									>
										<HealthCareAddOnContext.Provider
											value={{ healthCareAddOn, setHealthCareAddOn }}
										>
											<ValueMealAddonContext.Provider
												value={{ valueMealAddOn, setValueMealAddOn }}
											>
												<InsuranceAddonContext.Provider
													value={{ insuranceAddOn, setInsuranceAddOn }}
												>
													<TotalBusFareContext.Provider
														value={{ TotalBusFare, setTotalBusFare }}
													>
														<BusFareDepartContext.Provider
															value={{ BusFareDepart, setBusFareDepart }}
														>
															<BusFareReturnContext.Provider
																value={{ BusFareReturn, setBusFareReturn }}
															>
																<BusFareAddOnContext.Provider
																	value={{ BusFareAddOn, setBusFareAddOn }}
																>
																	<LoyaltyDiscountContext.Provider
																		value={{ TotalLoyalty, setLoyalty }}
																	>
																		<LoyaltyIDContext.Provider
																			value={{ LoyaltyID, setLoyaltyID }}
																		>
																			<ChildAmountContext.Provider
																				value={{ childAmount, setChildAmount }}
																			>
																				<OriginContext.Provider
																					value={{ origin, setOrigin }}
																				>
																					<VoucherDiscountContext.Provider
																						value={{
																							VoucherDiscount,
																							setVoucherDiscount,
																						}}
																					>
																						<VoucherCodeContext.Provider
																							value={{
																								VoucherCode,
																								setVoucherCode,
																							}}
																						>
																							<VoucherCodeAirlineContext.Provider
																								value={{
																									VoucherCodeAirlineNo,
																									setVoucherCodeAirlineNo,
																								}}
																							>
																								{/* Conditionally render Navbar and Footer */}
																								{/* {window.location.pathname !== '/eticket' && !window.location.pathname.includes('/resetPassword') && <Navbar />} */}
																								{/* {window.location.pathname.includes('/resetPassword') ? null : <Navbar />} */}

																								<Routes>
																									{/* Routes without Navbar and Footer */}
																									<Route
																										path='/resetPassword'
																										element={<ResetPassword />}
																									/>
																									<Route
																										path='/eticket'
																										element={<OrderSummary />}
																									/>

																									{/* Routes with Navbar and Footer */}
																									<Route
																										element={<MainLayout />}
																									>
																										<Route
																											exact
																											path='/'
																											element={
																												<Home
																													subplace_data={
																														subplace_data
																													}
																												/>
																											}
																										/>
																										{/* <Route path='/resetPassword' element={<ResetPassword />} /> */}
																										<Route
																											path='/busSchedule'
																											element={<BusSchedule />}
																										/>
																										<Route
																											path='/manageBooking'
																											element={
																												<ManageBooking />
																											}
																										/>
																										<Route
																											path='/loyalty'
																											element={<Loyalty />}
																										/>
																										<Route
																											path='/about'
																											element={<About />}
																										/>
																										{/* <Route path='/bookingEdit' element={<BookingEdit />} /> */}

																										<Route
																											path='/pickDepart'
																											element={
																												<PickDepart
																													subplace_data={
																														subplace_data
																													}
																												/>
																											}
																										/>
																										<Route
																											path='/pickReturn'
																											element={
																												<PickReturn
																													subplace_data={
																														subplace_data
																													}
																												/>
																											}
																										/>
																										<Route
																											path='/selectSeat'
																											element={
																												<ProceedComponent />
																											}
																										/>
																										<Route
																											path='/checkout'
																											element={<Checkout />}
																										/>
																										<Route
																											path='/PaymentAck'
																											element={<PaymentAck />}
																										/>

																										<Route
																											path='/booking_status'
																											element={
																												<BookingStatus />
																											}
																										/>
																										<Route
																											path='/bookingHistory'
																											element={
																												<BookingHistory />
																											}
																										/>
																										<Route
																											path='/myAccount'
																											element={<MyAccount />}
																										/>
																										<Route
																											path='/bookingSummary'
																											element={<BookingSummary />}
																										/>
																									</Route>
																								</Routes>
																								{/* {window.location.pathname.includes('/resetPassword') ? null : <Footer />} */}
																								{/* {window.location.pathname !== '/eticket' && !window.location.pathname.includes('/resetPassword') && <Footer />} */}
																							</VoucherCodeAirlineContext.Provider>
																						</VoucherCodeContext.Provider>
																					</VoucherDiscountContext.Provider>
																				</OriginContext.Provider>
																			</ChildAmountContext.Provider>
																		</LoyaltyIDContext.Provider>
																	</LoyaltyDiscountContext.Provider>
																</BusFareAddOnContext.Provider>
															</BusFareReturnContext.Provider>
														</BusFareDepartContext.Provider>
													</TotalBusFareContext.Provider>
												</InsuranceAddonContext.Provider>
											</ValueMealAddonContext.Provider>
										</HealthCareAddOnContext.Provider>
									</SelectSeatReturnContext.Provider>
								</SelectSeatDepartContext.Provider>
							</ReturnDataContext.Provider>
						</DepartDataContext.Provider>
					</CurrencyContext.Provider>
				</CurrentCurrencyContext.Provider>
			</Router>
		</>
	);
}

export default App;
